<template>
  <a ref="video"
     target="_blank"
     class="youtube-item"
     :href="link"
     @click.prevent="handleClick(link)">
    <div class="youtube-item__img-wrap">
      <img
        class="youtube-item__img"
        :src="image"
        :alt="title"
        loading="lazy"
        data-force-load="true"
      />
      <div class="play-video-btn" :class="{ 'play-video-btn--plain': plainButton }"></div>
    </div>
    <div class="youtube-item__info">
      <span class="youtube-item__date">{{ date }}</span>
    </div>
    <h4 class="youtube-item__title">{{ title }}</h4>
  </a>
</template>

<script>
import { transliteration } from '../../../mixins/transliteration'
import { GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'YoutubeItem',
  mixins: [transliteration],
  props: {
    blockName: {
      type: String,
      default: ''
    },
    videoId: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    position: {
      type: Number,
      default: null
    },
    redirect: {
      type: Boolean,
      default: false
    },
    plainButton: {
      type: Boolean,
      default: false
    },
    isSlider: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async handleClick (link) {
      // await GoogleTagManagerService.promotionClickEvent({
      //   analyticsData: [
      //     {
      //       'name': this.transliterate(this.title),
      //       'creative': this.transliterate(this.blockName),
      //       'position': 'slot' + this.position
      //     }
      //   ]
      // })

      this.redirect
        ? (location.href = link)
        : this.$modal.show('content-modal', { type: 'video', videoId: this.videoId })
    }
  },
  mounted () {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        GoogleTagManagerService.promotionViewEvent({
          analyticsData: [
            {
              'name': this.transliterate(this.title),
              'creative': this.transliterate(this.blockName),
              'position': 'slot' + this.position
            }
          ]
        })

        observer.unobserve(this.$refs.video)
      }
    })
    setTimeout(() => {
      observer.observe(this.$refs.video)
    }, 0)
  }
}
</script>

<style scoped lang="sass">

.youtube-item__img-wrap
  position: relative
  overflow: hidden
  cursor: pointer
  padding-bottom: calc(56.25% - 2px)
  height: 0

.youtube-item__img
  width: 100%
  cursor: pointer
  object-fit: contain

  +mmin($extsmall)
    position: absolute
    top: 50%
    transform: translateY(-50%)

.youtube-item__info
  margin-top: 20px

.youtube-item__date
  color: $placeholder-color
  font-size: 12px

.youtube-item__title
  color: $text-color
  font-size: 14px
  font-weight: 400
  margin: 10px 0 0

  +mmin($tablet--hor)
    font-size: 16px

// video btn
.play-video-btn
  width: 40px
  height: 40px
  background-color: $main-color
  box-shadow: 0 0 30px rgba( 0,0,0,0.6 )
  z-index: 1
  border-radius: 50%
  cursor: pointer
  position: absolute
  top: 50%
  left: 50%
  transform: translate3d( -50%, -50%, 0 )
  transition: all .3s

  &:hover
    background-color: $text-color
    opacity: .9

  &:before
    content: ''
    position: absolute
    border-style: solid
    border-width: 6px 0 6px 12px
    border-color: transparent transparent transparent #fff
    top: 50%
    left: 50%
    transform: translate3d( -40%, -50%, 0 )
    transition: all .3s

  &--plain
    border: 3px solid #fff
    background-color: transparent

    &:hover
      border-color: darken(#fff, 15%)
      background-color: transparent

      &:before
        border-color: transparent transparent transparent darken(#fff, 15%)
</style>
